import { Dispatch, SetStateAction } from 'react';
import BacktestComparisonTab from './BacktestComparisonTab';
import BacktestSingleTab from './BacktestSingleTab';
import {
  BacktestResult,
  ComparisonResponse,
  StrategyInfo,
} from '../../services/backtestApi';

const TABS = [
  { id: 'single', label: '단일 전략' },
  { id: 'comparison', label: '전략 비교' },
] as const;

export default function UsBacktestPanel(props: UsBacktestPanelProps) {
  return (
    <>
      <div className="backtest-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => props.setActiveTab(tab.id)}
            className={`backtest-tab ${
              props.activeTab === tab.id ? 'backtest-tab-active' : ''
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {props.error && <div className="backtest-error-banner">{props.error}</div>}
      {props.activeTab === 'single' && (
        <BacktestSingleTab
          symbol={props.symbol}
          onSymbolChange={props.setSymbol}
          strategy={props.strategy}
          onStrategyChange={props.setStrategy}
          period={props.period}
          onPeriodChange={props.setPeriod}
          initialCapital={props.initialCapital}
          onInitialCapitalChange={props.setInitialCapital}
          strategies={props.strategies}
          loading={props.loading}
          result={props.backtestResult}
          interpretation={props.interpretation}
          onRun={props.onRun}
        />
      )}
      {props.activeTab === 'comparison' && (
        <BacktestComparisonTab
          symbol={props.symbol}
          onSymbolChange={props.setSymbol}
          period={props.period}
          onPeriodChange={props.setPeriod}
          loading={props.loading}
          result={props.comparisonResult}
          onCompare={props.onCompare}
        />
      )}
    </>
  );
}

interface UsBacktestPanelProps {
  activeTab: 'single' | 'comparison';
  setActiveTab: Dispatch<SetStateAction<'single' | 'comparison'>>;
  symbol: string;
  setSymbol: Dispatch<SetStateAction<string>>;
  strategy: string;
  setStrategy: Dispatch<SetStateAction<string>>;
  period: '3M' | '6M' | '1Y';
  setPeriod: Dispatch<SetStateAction<'3M' | '6M' | '1Y'>>;
  initialCapital: number;
  setInitialCapital: Dispatch<SetStateAction<number>>;
  strategies: StrategyInfo[];
  backtestResult: BacktestResult | null;
  comparisonResult: ComparisonResponse | null;
  loading: boolean;
  error: string | null;
  interpretation: string | null;
  onRun: () => void;
  onCompare: () => void;
}
